import { Box, IconButton, Theme, Tooltip, Typography } from "@mui/material";
import { EditRounded } from "@mui/icons-material";
import moment from "moment";
import { AdminToggle, DataTableColumn } from "../../../components/ui";
import { CouponModel } from "../../../services/coupon/coupon.services";
import { formatDiscount } from "./coupon-format";

type Options = {
    theme: Theme;
    onToggle: (coupon: CouponModel) => void;
    onEdit: (coupon: CouponModel) => void;
};

/** Colunas da tabela de cupons (Cupom / Desconto / Validade / Usos / Status / Ações). */
export function buildCouponColumns({ theme, onToggle, onEdit }: Options): DataTableColumn<CouponModel>[] {
    return [
        {
            key: "code",
            header: "Cupom",
            width: "1.4fr",
            render: (row) => (
                <Box
                    component="span"
                    sx={{
                        display: "inline-block",
                        px: "8px",
                        py: "2px",
                        borderRadius: "6px",
                        fontSize: "12.5px",
                        fontWeight: 600,
                        fontFamily: "monospace",
                        letterSpacing: "0.5px",
                        color: "text.primary",
                        backgroundColor: theme.palette.brand?.cream ?? theme.palette.action.selected,
                        border: `1px solid ${theme.palette.divider}`,
                    }}
                >
                    {row.code}
                </Box>
            ),
        },
        {
            key: "desconto",
            header: "Desconto",
            width: "1fr",
            render: (row) => (
                <Typography sx={{ fontSize: "13.5px", color: "text.primary", fontWeight: 500 }}>{formatDiscount(row)}</Typography>
            ),
        },
        {
            key: "expiration_date",
            header: "Validade",
            width: "1fr",
            render: (row) => (
                <Typography sx={{ fontSize: "13.5px", color: "text.secondary" }}>
                    {row.expiration_date ? moment(row.expiration_date).utcOffset(-180).format("DD/MM/YYYY") : "—"}
                </Typography>
            ),
        },
        {
            key: "usages",
            header: "Usos",
            width: "1fr",
            render: (row) => (
                <Typography sx={{ fontSize: "13.5px", color: "text.secondary" }}>
                    {row.usages ?? 0}
                    {row.quantity ? ` / ${row.quantity}` : ""}
                </Typography>
            ),
        },
        {
            key: "status",
            header: "Status",
            width: "1.2fr",
            render: (row) => (
                <AdminToggle checked={row.enabled ?? false} onChange={() => onToggle(row)} label={row.enabled ? "Habilitado" : "Desabilitado"} />
            ),
        },
        {
            key: "actions",
            header: "Ações",
            width: "80px",
            align: "right",
            render: (row) => (
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Tooltip title="Editar cupom" placement="top">
                        <IconButton
                            size="small"
                            aria-label="Editar cupom"
                            onClick={(e) => {
                                e.stopPropagation();
                                onEdit(row);
                            }}
                            sx={{ borderRadius: "8px" }}
                        >
                            <EditRounded sx={{ fontSize: 17 }} />
                        </IconButton>
                    </Tooltip>
                </Box>
            ),
        },
    ];
}
